import React, { FC } from 'react';

import { useFormikContext } from 'formik';

import { Label } from 'components/ui/label';
import { Switch } from 'components/ui/switch';

import type { StoreOrientationFormValues } from '../storeSettingsView.types';

export const StoreOrientationSectionFields: FC = () => {
  const { values, setFieldValue } =
    useFormikContext<StoreOrientationFormValues>();

  return (
    <div className="rounded-lg border border-zinc-200 bg-base-background p-4">
      <div className="flex shrink-0 items-center justify-between gap-2">
        <Label
          htmlFor="store-orientation-show-rotate-prompt"
          className="cursor-pointer font-sans text-sm font-medium text-base-foreground"
        >
          Show orientation message
        </Label>
        <Switch
          id="store-orientation-show-rotate-prompt"
          checked={!!values.showRotatePrompt}
          onCheckedChange={(checked) =>
            setFieldValue('showRotatePrompt', checked)
          }
          data-testid="storeOrientationShowRotatePrompt"
          className="mt-0.5 h-5 w-9 shrink-0 shadow-none bg-zinc-200 data-[state=unchecked]:bg-zinc-200 data-[state=checked]:bg-base-primary [&>span]:bg-base-background data-[state=checked]:[&>span]:translate-x-4"
        />
      </div>
    </div>
  );
};
